import React from 'react';
import styled from 'styled-components';
import { Anchor, CircleButton, mercury } from '@parchment/atoms';
import { IndianaAchievementWalletIcon, RevertIcon } from '@parchment/icons';

const noop = () => {};

export default function LearnerInfoBanner({
    learnerBannerUserImageUrl = '',
    learnerName = '',
    dashboardUrl = '',
    showAchievementShareButton = false,
    achievementOnClick = noop
}) {
    return (
        <LearnerBannerWrapper>
            <LearnerInfoSection>
                <StyledLearnerIcon className='learner-icon'
                                   src={learnerBannerUserImageUrl}
                                   alt="Parchment user profile photo" />
                <LearnerTextWrapper>
                    <LearnerName className='learner-name'>
                        {learnerName}
                    </LearnerName>
                    {
                        dashboardUrl && (
                            <StyledAnchor className='dashboard-link'
                                          href={dashboardUrl}>
                                <RevertIcon contextType='text' />
                                Back To Dashboard
                            </StyledAnchor>
                        )
                    }
                </LearnerTextWrapper>
            </LearnerInfoSection>
            {
                showAchievementShareButton && (
                    <AchievementShareButtonWrapper className='achievement-share-button'
                                                   onClick={achievementOnClick}>
                        <CircleButton name='indiana-wallet-share'
                                      context='dark'
                                      ghost >
                            <IndianaAchievementWalletIcon />
                        </CircleButton>
                        <div>
                            Share to Indiana Achievement Wallet
                        </div>
                    </AchievementShareButtonWrapper>
                )
            }
        </LearnerBannerWrapper>
    );
}

const LearnerBannerWrapper = styled.div`
    height: 100px;
    position: absolute;
    left: 0;
    right: 0;
    margin-top: -115px;
    background-color: ${mercury};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 18%;
`;

const StyledLearnerIcon = styled.img`
    height: 60px;
    width: 60px;
    border-radius: 50%;
`;

const LearnerInfoSection = styled.div`
    display: flex;
    flex-direction: row;
`;

const LearnerTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    font-weight: 600;
`;

const LearnerName = styled.div`
    font-size: 1.5em;
`;

const StyledAnchor = styled(Anchor)`
    &:hover {
        text-decoration: none;
    }
`;

const AchievementShareButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    float: right;
    text-align: center;
    cursor: pointer;

    > button > span {
        font-size: 40px;
    }
`;
